const supportedLanguages = ['en', 'ar']

module.exports = supportedLanguages
